import { IExpression } from "@@expressions";
import { VarExpression } from "../../ExpressionsModule/Models/VarExpression";
import { IContainerComponent } from "./IContainerComponent";
import { PropertyDisplayFormat } from "./PropertyDisplayFormat";
import { TableColumnActionModel } from "./TableColumnActionModel";

export enum ListWithSideDetailDirection {
  Left = "Left",
  Right = "Right",
}

export type ListWithSideDetailItemModel = {
  PrimaryTextField?: string;
  PrimaryTextFormat?: PropertyDisplayFormat;
  SecondaryTextField?: string;
  SecondaryTextFormat?: PropertyDisplayFormat;
  SupportingTextField?: string;
  SupportingTextFormat?: PropertyDisplayFormat;
  IconName?: string;
  BadgeField?: string;
  BadgeFormat?: PropertyDisplayFormat;
};

export type ListWithSideDetailModel = IContainerComponent & {
  Title?: string;
  HeaderTitle?: string;
  HeaderIcon?: string;
  HeaderActions?: TableColumnActionModel[];
  UsePaper?: boolean;
  GetItems: IExpression;
  KeyField?: string;
  Items?: ListWithSideDetailItemModel[];
  PrimaryTextField?: string;
  PrimaryTextFormat?: PropertyDisplayFormat;
  SecondaryTextField?: string;
  SecondaryTextFormat?: PropertyDisplayFormat;
  SupportingTextField?: string;
  SupportingTextFormat?: PropertyDisplayFormat;
  IconName?: string;
  BadgeField?: string;
  BadgeFormat?: PropertyDisplayFormat;
  ListWidth?: number;
  PersistSelection?: boolean;
  PersistedStateKey?: string;
  ItemQueryKey?: string;
  Direction?: ListWithSideDetailDirection;
  Item?: VarExpression;
  OnItemSelected?: IExpression;
};
